import './InlineEditButton.less';
import React, {useState, useEffect} from 'react';
import __ from "../../../../i18n";
import PopupEditButton from "../../../../widgets/popup-edit-button/PopupEditButton";
import QuizEditor from "../../../../editors/quiz/QuizEditor";


/**
 *
 * @param {IQuiz} item
 * @param refs
 * @param {function} onDone
 * @return {React.Component}
 * @constructor
 */
export default function InlineEditButton({item, refs, onDone}) {

    const isCreation = !item;

    return <PopupEditButton
        popupTitle={isCreation ? __('Add new quiz') : __('Edit quiz')}
        getEditor={(close) => <QuizEditor
            recordId={isCreation ? null : item.id}
            defaultData={{
                quiz: item,
                questionGroups: refs.questionGroups.filter(t => t.quiz_id === item.id),
                questions: refs.questions.filter(t => t.quiz_id === item.id),
            }}
            onDone={(values) => {
                onDone(values);
                close();
            }}
            onCancel={() => {
                close();
            }}
        />}
    />;
}
